import { Controller } from "@hotwired/stimulus";

// Bottom sheet that slides up from the bottom of the screen.
// Opens via "bottom-sheet:open" window event (fired by tab bar button).
// Usage: data-controller="bottom-sheet"
export default class extends Controller {
  static targets = ["overlay", "sheet"];

  connect() {
    this.#boundOpen = () => this.open();
    window.addEventListener("bottom-sheet:open", this.#boundOpen);
  }

  disconnect() {
    window.removeEventListener("bottom-sheet:open", this.#boundOpen);
  }

  open() {
    this.overlayTarget.classList.remove("hidden");
    this.sheetTarget.classList.remove("translate-y-full");
  }

  close() {
    this.sheetTarget.classList.add("translate-y-full");
    setTimeout(() => this.overlayTarget.classList.add("hidden"), 300);
  }

  closeOnKeydown(event) {
    if (event.key === "Escape") {
      this.close();
    }
  }

  #boundOpen;
}
